import BankTransferInfo from 'apps/auth/components/history/send/BankTransferInfo';
import BankTransferStatus from 'apps/auth/components/send/BankTransferStatus';
import FromInteracAccountStatusBean from 'apps/auth/components/status/FromInteracAccountStatusBean';
import MastercardPromoIntro from 'apps/auth/components/status/MastercardPromoIntro';
import PromoInviteCodeIntro from 'apps/auth/components/status/PromoInviteCodeIntro';
import SepaStatus from 'apps/auth/components/status/SepaStatus';
import { BUNDLE } from 'apps/auth/constants/EntryPoint';
import { AUTH_VIEW } from 'apps/auth/constants/ServerConstants';
import LoadingPage from 'apps/auth/pages/deepLink/LoadingPage';
import DeliveryOptionsPage from 'apps/auth/pages/send/DeliveryOptionsPage';
import GTAccountDetailsPage from 'apps/auth/pages/send/GTAccountDetailsPage';
import GTDownloadPage from 'apps/auth/pages/send/GTDownloadPage';
import GTSendMultiPage from 'apps/auth/pages/send/GTSendMultiPage';
import GTStubPage from 'apps/auth/pages/send/GTStubPage';
import SendMainPage from 'apps/auth/pages/send/SendMainPage';
import SendSelectCountryPage from 'apps/auth/pages/send/SendSelectCountryPage';
import StatusAuthPage from 'apps/auth/pages/StatusAuthPage';

const authSend = [
    {
        path: ['/auth/send/status/sepa/:action'],
        component: SepaStatus,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
        },
    },
    {
        path: ['/auth/send/status/account-details'],
        component: GTAccountDetailsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
        },
    },
    {
        path: ['/auth/send/main.page'],
        component: SendMainPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            isChatBottomUp: true,
        },
    },
    {
        path: ['/auth/promo/mastercard'],
        component: MastercardPromoIntro,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
        },
    },
    {
        path: ['/auth/send/from-people-trust-interac-info/:paymentId', '/auth/send/from-interac-info/:paymentId'],
        component: FromInteracAccountStatusBean,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
        },
    },
    {
        path: '/auth/send/bank-transfer/:status',
        component: BankTransferStatus,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isChatBottomUp: true,
        },
    },
    {
        path: '/auth/send/:countryCodeA2/:currencyIso/:deliveryMethod',
        exact: true,
        component: GTSendMultiPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: false,
        },
    },
    {
        path: '/auth/send/repeat',
        exact: true,
        component: GTSendMultiPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: false,
            repeat: true,
        },
    },
    {
        path: '/auth/bonus/repeat',
        exact: true,
        component: GTSendMultiPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            isBonus: true,
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: false,
            repeat: true,
        },
    },
    {
        path: '/auth/send/:countryCodeA2/delivery',
        exact: true,
        component: DeliveryOptionsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: false,
            newComponent: true,
        },
    },
    {
        path: '/auth/send/:countryCodeA2/:currencyIso',
        exact: true,
        component: DeliveryOptionsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: false,
        },
    },
    {
        path: ['/auth/send', '/auth/send/:countryCodeA2'],
        exact: true,
        component: SendSelectCountryPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
        },
    },
    {
        path: ['/auth/pay/status/request', '/auth/pay/status/request:id', '/auth/pay/waiting'],
        component: StatusAuthPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
        },
    },
    {
        path: ['/auth/profile/promo-invite-code-intro'],
        component: PromoInviteCodeIntro,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            showChat: false,
        },
    },
    {
        path: '/auth/gt/stub-page',
        component: GTStubPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: false,
        },
    },
    {
        path: '/auth/gt/download',
        component: GTDownloadPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: false,
        },
    },
    {
        path: '/auth/payments/history/bank-transfer-info',
        component: BankTransferInfo,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
        },
    },
    {
        path: ['/auth/finish/draft/transaction', '/auth/finish/verification'],
        exact: true,
        component: LoadingPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
        },
    },
];

export default authSend;
